<template>
  <div style="width:100%;">
    <p class="floating-placeholder" v-if="floating" :class="{'focus-placeholder':(isFocus)}">{{placeholder}}</p>
    <div class="select-wrapper">
      <select
        class="nerz-select"
        :value="value"
        @change="updateValue"
        @focus="focusSelect($event)"
        @blur="blurSelect($event)"
      >
      <option value="" style="display: none;" class="placeholder">{{placeholder}}</option>
      <option v-for="(val, key) in options"
        :key="key"
        :value="val.value"
      >{{ val.label }}</option>
    </select>
  </div>
</div>
</template>
<script>
  export default {
    props: {
      value: {type: [String, Number]},
      options: { type: Array, required: true },
      placeholder: { type: [ String, Number ] },
      action: {type: Object},
    },

    data() {
      return {
        floating: false,
        isFocus: false,
      }
    },

    created() {
      this.checkValue()
    },

    methods: {
      updateValue (e) {
        let value = e.target.selectedOptions.length ? e.target.selectedOptions[0]._value : null
        this.$emit('input', value)
        if(this.$listeners.nullCheckVal) {
          this.$emit('nullCheckVal')
        }
      },

      checkValue() {
        if(this.value) {
          this.floating = true
        }
      },

      focusSelect(event) {
        this.floating = true
        this.isFocus = true
        this.$emit('focus', event)
      },

      blurSelect(event) {
        this.isFocus = false
        this.$emit('blur', event)
        this.checkValue()
      },

    }
  }

</script>

<style scoped>

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.nerz-select {
  padding: 5px;
  border: 0;
  border-bottom: 1px solid #707070;
  width: 100%;
  background: transparent;
}

.select-wrapper {
  position: relative;
}

.select-wrapper::after {
  display: block;
  content: "";
  position: absolute;
  right: 3%;
  top: 40%;
  width: 30px;
  height: 30px;
  border-right: 15px solid transparent;
  border-top: 10px solid #F39939;
  border-left: 15px solid transparent;
}

.nerz-select:focus {
  border-bottom: 2px solid #f3983b;
  outline: 0;
}

.floating-placeholder {
  font-size: 12px;
  line-height: 1;
  margin-block-end: 0px;
  margin-bottom: 5px!important;
  margin-left: 5px;
  color: #515659;
  font-weight: bold;
}

.focus-placeholder {
  color: #f3983b;
}

::placeholder {
  font-size: 14px;
}
</style>
